import "./SettingsComponent.css";

export default function SettingsComponent() {
    return (
        <>
            <div className="settings-init shadow-drop-settings-bottom">
                <div className="settings-init-left">Impostazioni</div>
                <div className="settings-init-right">
                    <div className="settings-init-right__left">Pagina</div>
                    
                </div>
            </div>

            <div className="settings-container">
                
            </div>
        </>
    );
}